import React, { FC } from 'react';
import { RadioGroup, FormControlLabel, Radio, Typography, FormHelperText } from '@material-ui/core';
import clsx from 'clsx';
import { stylesCalculator } from '../../styles/calculator';
import { getCommon } from '../../styles/common';

interface CalculatorProps {
    gender: string;
    errorMessageGender: string;
    handleChangeGender: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const GenderInput: FC<CalculatorProps> = (props: CalculatorProps) => {
    const common = getCommon();
    const classes = stylesCalculator();
    const { gender, errorMessageGender, handleChangeGender } = props;

    return (
        <div className={classes.container}>
            <Typography className={classes.title} variant="h4" component="p">
                Sexo
            </Typography>
            <RadioGroup
                color={common.colors.primary()}
                aria-label="gender"
                name="gender"
                value={gender}
                onChange={handleChangeGender}
            >
                <FormControlLabel
                    className={classes.inputContainer}
                    value="male"
                    control={<Radio />}
                    label={
                        <div className={classes.textIconContainer}>
                            <i className={`fas fa-male  ${classes.radioIcon}`} />
                            <Typography className={classes.radioText} variant="h5" component="span">
                                Homem
                            </Typography>
                        </div>
                    }
                />

                <FormControlLabel
                    value="female"
                    className={classes.inputContainer}
                    control={<Radio />}
                    label={
                        <div className={classes.textIconContainer}>
                            <i className={`fas fa-female ${classes.radioIcon}`} />

                            <Typography className={classes.radioText} variant="h5" component="span">
                                Mulher
                            </Typography>
                        </div>
                    }
                />
            </RadioGroup>
            <FormHelperText className={clsx(errorMessageGender === '' && classes.hide, classes.errorText)}>
                {errorMessageGender}
            </FormHelperText>
        </div>
    );
};

export default GenderInput;
